<template>
  <div class="form-fw__footer" :class="{ 'form-fw__footer--shadow': shadow }">
    <footer>
      <v-layout align-center justify-end row class="py-2 px-4">
        <v-flex sm4 md6>
          <a
            v-if="step === 1"
            href="#"
            class="text--normal accent--text mr-4"
            color="accent"
            flat
            round
            @click.prevent="prevPage"
          >{{ $t('Common.cancel') }}</a>
          <v-btn
            v-if="step === 1"
            type="submit"
            round
            depressed
            color="accent"
            :loading="isProcessing"
          >{{ $t(`${namespace}.exportLabel`) }}</v-btn>
          <v-btn
            v-if="step === 2"
            href="#"
            color="accent"
            depressed
            round
            @click.prevent="prevPage"
          >{{ $t('Common.ok')}}! {{$t(`${namespace}.gotToReports`)}}</v-btn>
        </v-flex>
      </v-layout>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ConsolidatedReportFooter',
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      namespace: 'Views.ConsolidatedReportPage',
      shadow: false
    }
  },
  methods: {
    prevPage () {
      this.$router.push({ name: 'ConsolidatedReports' })
    },

    exportNewReport () {
      this.$emit('exportNewReport')
    },

    handleShadow () {
      this.shadow = window.scrollY > 0
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
